import { Button, Modal, Text, useToastContext } from '@payaca/ambrosia';
import { FC } from 'react';

import useResendUserInvite from '@/api/mutations/account/useResendUserInvite';

type Props = {
  userPublicId?: string;
  userName?: string;
  isOpen: boolean;
  onClose: () => void;
};

const ConfirmResendInviteModal: FC<Props> = (props) => {
  const { userPublicId, userName, isOpen, onClose } = props;
  const { pushSuccess } = useToastContext();

  const { mutate: resendUserInvite, isPending } = useResendUserInvite({
    onSuccess: () => {
      pushSuccess('Invite sent');
      onClose();
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Resend invite">
      <Modal.Body>
        <Text>
          We will email {userName || 'this person'} a new invitation, valid for
          48 hours. The link in their previous invitation will stop working.
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button variant="secondary" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (!userPublicId) return;
              resendUserInvite({ userId: userPublicId });
            }}
            isProcessing={isPending}
          >
            Resend invite
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmResendInviteModal;
